import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

let reactPlugin = null;
let appInsights = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
  const initialize = (browserHistory) => {
    const instrumentationKey = global.CLIENT_ENV.APPLICATIONINSIGHTS_INSTRUMENTATION_KEY;
    if (!browserHistory) {
      throw new Error('Could not initialize Telemetry Service');
    }
    if (!instrumentationKey) {
      throw new Error('Instrumentation key not provided');
    }

    reactPlugin = new ReactPlugin();

    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        maxBatchInterval: global.CLIENT_ENV.APPLICATIONINSIGHTS_BATCH_INTERVAL,
        disableFetchTracking: global.CLIENT_ENV.APPLICATIONINSIGHTS_DISABLE_FETCH_TRACKING,
        disableAjaxTracking: global.CLIENT_ENV.APPLICATIONINSIGHTS_DISABLE_AJAX_TRACKING,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });

    appInsights.loadAppInsights();
    appInsights.trackPageView();
  };

  return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
